export default "__VITE_ASSET__de8fdeff__"